import React from 'react';
import { useTranslation } from 'react-i18next';
import { HighlightSection, ScriptHeader, ScriptSection } from '../styles';
import { Line } from '@slides/styles';

export const SectionOne = ({ details }) => {
    const { t } = useTranslation();
    const { creditorData: creditors, totalBalance, totalPayment } = details;

    return (
        <>
            <ScriptHeader>
               {t('your_analysis.script.title')}
            </ScriptHeader>
            <Line />
            <div>{t('your_analysis.script.1')}</div>
            <ScriptSection>
                <strong>{t('your_analysis.script.2')}</strong>
            </ScriptSection>
            <div>
                    {t('your_analysis.script.3')}
                    <strong>{creditors.length} {t('your_analysis.script.4')}</strong>
                    {t('your_analysis.script.5')}
                    <strong>{totalBalance}</strong>
                    {t('your_analysis.script.6')}
                    <strong>
                        {totalPayment} {t('your_analysis.script.7')}
                    </strong>
                    {t('your_analysis.script.8')}
            </div>
            <HighlightSection>
                <strong>{t('your_analysis.script.9')}</strong>
            </HighlightSection>
        </>
    );
};
